// extracted by css-extract-rspack-plugin
export default {"cls1":"CreateSocialItem-cls1_EoV","cls2":"CreateSocialItem-cls2_l8s CreateSocialItem-cls1_EoV"};